import React, { Component } from "react";
import AnalyticsDispatcher from "dispatchers/analytics-dispatcher";
import { connect } from "react-redux";
import PromoLinkCard from "visual-components/analytics/campaign/promo-link-card";

class PromoEntries extends Component {
  state = {
    hideMap: {},
  };

  updateBrand = (brandId) => {
    const data = {
      metric: "campaignEntryContributionStatsByPartnerByPromoUnit",
      campaignId: this.props.campaignId,
      specificBrandId: brandId,
    };

    AnalyticsDispatcher.fetchReport(data, "analyticsCampaign");
  };

  toggleItem = (item) => {
    const hideMap = this.state.hideMap;
    hideMap[item] = !hideMap[item];

    this.setState({
      hideMap: hideMap,
    });
  };

  render() {
    const { data, isSolo, className = "" } = this.props;

    return (
      <PromoLinkCard
        {...data}
        toggle={this.toggleItem}
        className={`!w-auto ${className}`}
        onChange={this.updateBrand}
        hideMap={this.state.hideMap}
        isSolo={isSolo}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.analyticsCampaign.campaignEntryContributionStatsByPartnerByPromoUnit,
    campaignId: state.analyticsCampaign.campaign.id,
    isSolo: state.analyticsCampaign.campaign.isSolo,
  };
};

export default connect(mapStateToProps)(PromoEntries);
